<template>
    <section class="team-table">
        <el-table :data="items" 
                  style="width: 100%" 
                  empty-text="No Teams" 
                  @row-click="handleClick">
            <el-table-column v-if="showColumn('name')" prop="name" label="Name">
                <template slot-scope="scope">
                    <router-link
                        :aria-label="'Team: '+ scope.row.name"
                        :to="{ name: 'teams.detail', params: { uuid: scope.row.uuid } }"
                        event
                        @click.prevent="handleClick(scope.row)">{{ scope.row.name }}</router-link>
                </template>
            </el-table-column>
            <el-table-column
                v-if="showColumn('students_count')"
                prop="students_count"
                label="# of Students"/>
            <el-table-column
                v-if="showColumn('apa')"
                prop="apa"
                label="APA"/>
        </el-table>
    </section>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'travel-table',
    props: {
        items: {
            type: Array,
            default() {
                return []
            }
        },
        handleClick: {
            default() {
                return team => {
                    this.$router.push({
                        name: 'teams.detail',
                        params: { uuid: team.uuid }
                    })
                }
            }
        },
        columns: {
            type: Array,
            default() {
                return ['name', 'students_count', 'apa']
            }
        }
    },
    methods: {
        ...mapActions(['getTravelList']),
        showColumn(column) {
            return this.columns.indexOf(column) >= 0
        }
    }
}
</script>

<style lang="stylus"></style>
